import ShareOutlined from '@icons/ShareOutlined';
import ArrowForwardOutlined from '@icons/ArrowForwardOutlined';
import { Box, Fab, IconButton, Tooltip, Typography } from '@mui/material';
import { SavedView } from '@types';
import dayjs from 'dayjs';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export interface ShareButtonViewsModalProps {
  onClose: () => void;
  onShare?: (view: SavedView) => void;
  view: SavedView;
  showOwner?: boolean;
}
const ShareButtonViewsModalViewRow = ({ view, onClose, showOwner, onShare }: ShareButtonViewsModalProps) => {
  const navigate = useNavigate();
  const onView = useCallback(() => {
    onClose();
    navigate(`/view/${view.id}`);
  }, [navigate, onClose, view.id]);
  const onShareClicked = useCallback(() => {
    if (onShare) {
      onShare(view);
    }
  }, [onShare, view]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
        alignItems: 'center',
        pr: 3
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          flex: 1
        }}
      >
        <Typography variant="h7">{view.name}</Typography>
        <Typography variant="body2">{showOwner ? `${view.location} | Shared by ${view.user_id}` : view.location}</Typography>
        <Typography variant="body2">{view.description}</Typography>
      </Box>
      <Typography>{dayjs(view.created_at).format('YYYY-MM-DD')}</Typography>
      <Tooltip title="Share this view" arrow={true}>
        <IconButton size="small" sx={{ color: 'text.secondary' }} onClick={onShareClicked}>
          <ShareOutlined />
        </IconButton>
      </Tooltip>

      <Fab color="primary" size="small" sx={{ color: 'white' }} onClick={onView}>
        <ArrowForwardOutlined />
      </Fab>
    </Box>
  );
};
export default memo(ShareButtonViewsModalViewRow);
